import { PERMISSIONS } from "../../constants/permissions";

// The Manufacturing sidebar. Item shape: components/layout/shell/Sidebar.jsx.
// The permissions are the ones the old top navbar checked, unchanged.

// Asset Management is switched on per tenant by the superadmin, and the API
// refuses everything while it is off, so the links go with it.
const assetsEnabled = (ctx) => Boolean(ctx.enabledModules?.includes("assets"));

export const MANUFACTURING_SECTIONS = [
  {
    items: [
      { to: "/manufacturing/dashboard", label: "Dashboard", icon: "dashboard" },
      { to: "/manufacturing/my-tasks", label: "My Tasks", icon: "tasks" },
    ],
  },
  {
    title: "Production",
    items: [
      {
        to: "/manufacturing/po-management",
        label: "PO Management",
        icon: "orders",
        // A new PO and a PO's own page belong to PO Management too.
        match: ["/manufacturing/po/"],
      },
      {
        to: "/manufacturing/assigned-tasks",
        label: "Assigned Tasks",
        icon: "assigned",
        permission: [PERMISSIONS.MANUFACTURING_ALLOTTED_TASK_VIEW, PERMISSIONS.MANUFACTURING_ALLOTTED_TASK_MANAGE],
      },
    ],
  },
  {
    title: "Inventory",
    items: [
      {
        to: "/manufacturing/inventory",
        label: "Stock",
        icon: "inventory",
        end: true,
        permission: PERMISSIONS.MANUFACTURING_INVENTORY_VIEW,
      },
      {
        to: "/manufacturing/inventory/movements",
        label: "Stock Movements",
        icon: "movements",
        permission: PERMISSIONS.MANUFACTURING_INVENTORY_VIEW,
      },
    ],
  },
  {
    title: "Assets",
    items: [
      {
        to: "/manufacturing/assets",
        label: "Asset Management",
        icon: "machine",
        // A machine's own page belongs here too.
        match: ["/manufacturing/assets/"],
        visible: assetsEnabled,
        permission: [
          PERMISSIONS.MANUFACTURING_ASSET_VIEW,
          PERMISSIONS.MANUFACTURING_ASSET_MANAGE,
          PERMISSIONS.MANUFACTURING_ASSET_MAINTAIN,
          PERMISSIONS.MANUFACTURING_ASSET_BREAKDOWN_REPORT,
        ],
      },
    ],
  },
  {
    title: "Insights",
    items: [{ to: "/manufacturing/reports", label: "Reports", icon: "reports" }],
  },
];

export const MANUFACTURING_ADMIN = {
  label: "Settings",
  icon: "settings",
  items: [
    {
      to: "/manufacturing/settings/workflows",
      label: "Workflow Templates",
      icon: "workflow",
      permission: PERMISSIONS.MANUFACTURING_WORKFLOW_MANAGE,
    },
    {
      to: "/manufacturing/settings/parts",
      label: "Parts Master",
      icon: "parts",
      permission: PERMISSIONS.MANUFACTURING_PARTS_MANAGE,
    },
    {
      to: "/manufacturing/settings/inventory",
      label: "Inventory Settings",
      icon: "customize",
      permission: PERMISSIONS.MANUFACTURING_INVENTORY_MANAGE,
    },
    {
      to: "/manufacturing/settings/customer-links",
      label: "Customer Links",
      icon: "link",
      permission: PERMISSIONS.MANUFACTURING_PORTAL_MANAGE,
    },
    {
      to: "/manufacturing/settings/assets",
      label: "Asset Settings",
      icon: "machine",
      visible: assetsEnabled,
      permission: PERMISSIONS.MANUFACTURING_ASSET_MANAGE,
    },
    { to: "/manufacturing/settings/users", label: "Users", icon: "users", permission: PERMISSIONS.USER_VIEW_ALL },
    { to: "/manufacturing/settings/roles", label: "Roles", icon: "roles", permission: PERMISSIONS.ROLE_VIEW },
    // Admin-only: who receives the admin's alerts is never granted through a role.
    { to: "/manufacturing/settings/alert-recipients", label: "Alert Recipients", icon: "bell", adminOnly: true },
    // Admin-only by design — the audit trail is never granted through a role's permissions.
    { to: "/manufacturing/settings/audit-logs", label: "Audit Trail", icon: "audit", adminOnly: true },
  ],
};
